/*eslint-disable*/
import { Flex, Link, List, ListItem, Text } from "@chakra-ui/react";
import React from "react";
import config from "config/index";

export default function Footer(props) {
  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent='space-between'
      px='30px'
      pb='20px'>
      <Text
        color='gray.400'
        fontSize="xs" 
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}>
        &copy; {1900 + new Date().getYear()},{" "}
        <Text as='span'>
          {document.documentElement.dir === "rtl"
            ? " ایجاد شده با ❤️ توسط"
            : "Made with ❤️ by "}
        </Text>
        <Link
          color='blue.400' 
          href={config.host}
          target='_blank'>
          {document.documentElement.dir === "rtl"
            ? " نمایشگاه مجازی ترنج"
            : "Toranj Panorama Tour "}
        </Link>
        <Text mr="10px" ml="10px" as='span'>
          V{config.version}
        </Text>
      </Text>
      <List display='flex'>
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}>
          <Link color='gray.400' fontSize="xs"  href={config.host}>
            {document.documentElement.dir === "rtl"
              ? "ترنج"
              : "Toranj"}
          </Link>
        </ListItem>
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}>
          <Link fontSize="xs" 
            color='gray.400'
            href={config.host+'/tour/demo'}>
            {document.documentElement.dir === "rtl" ? "دموی نمایشگاه" : "Demo"}
          </Link>
        </ListItem>
        <ListItem>
          <Link fontSize="xs" 
            color='gray.400'
            href={config.host+'/blog'}>
            {document.documentElement.dir === "rtl" ? "وبلاگ" : "Blog"}
          </Link>
        </ListItem>
      </List>
    </Flex>
  );
}
